import React from "react";
import useUpgradeFareInfoController from "./useUpgradeFareInfo.controller.js";
import { Text } from "@bookingcom/bui-react";
import { UpgradeFareInfoMobile } from "./UpgradeFareInfo.mobile.js";
import { track } from "@flights/et-universal";
const useUpgradeFareInfoMobile = (flight) => {
    const data = useUpgradeFareInfoController(flight);
    const { header, subheader, fareInfoContent } = data;
    if (!fareInfoContent)
        return undefined;
    return {
        header,
        subheader,
        content: !!track("flights_funnel_new_fd_page_mobile") ? (React.createElement(UpgradeFareInfoMobile, { ...data })) : (React.createElement("div", null,
            React.createElement(Text, { variant: "body_2" }, fareInfoContent.content),
            React.createElement(Text, { variant: "body_2" }, fareInfoContent.price),
            React.createElement(Text, { variant: "body_2" }, fareInfoContent.supportText)))
    };
};
export default useUpgradeFareInfoMobile;
